import React from 'react'
import { Modal, Button, Alert, Card, Row, Col } from 'react-bootstrap'

const StageMaterialsModal = ({ show, onHide, workStage, projectId }) => {
  if (!workStage) return null

  // Собираем все материалы из всех работ этапа
  const allMaterials = []
  if (workStage.works && workStage.works.length > 0) {
    workStage.works.forEach((work) => {
      if (work.materials && work.materials.length > 0) {
        work.materials.forEach((material) => {
          allMaterials.push({
            ...material,
            workName: work.work_name,
          })
        })
      }
    })
  }

  const handleDownloadPdf = () => {
    const url = `/projects/${projectId}/work_stages/${workStage.id}/stage_materials.pdf`
    window.open(url, '_blank')
  }

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton className="bg-secondary bg-opacity-10 border-0 pb-3">
        <div className="d-flex flex-column">
          <Modal.Title className="mb-1 fw-bold">
            <i className="bi bi-box-seam me-2"></i>
            Материалы этапа
          </Modal.Title>
          <small className="text-muted">{workStage.work_stage_name}</small>
        </div>
      </Modal.Header>
      <Modal.Body className="p-4">
        {allMaterials.length > 0 ? (
          <div className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <i className="bi bi-images fs-5 text-secondary me-2"></i>
              <h6 className="mb-0 fw-semibold">
                Всего материалов: {allMaterials.length}
              </h6>
            </div>
            <Row className="g-3">
              {allMaterials.map((material) => (
                <Col key={`${material.workName}-${material.id}`} lg={3} md={4} sm={6}>
                  <Card className="h-100 border shadow-sm">
                    {material.photo_url ? (
                      <Card.Img
                        variant="top"
                        src={material.photo_url}
                        style={{ height: '180px', objectFit: 'cover' }}
                        loading="lazy"
                      />
                    ) : (
                      <div
                        className="card-body text-center bg-light d-flex align-items-center justify-content-center"
                        style={{ height: '180px' }}
                      >
                        <div className="text-center">
                          <i className="bi bi-image fs-1 text-muted mb-2"></i>
                          <div className="small text-muted">Без фото</div>
                        </div>
                      </div>
                    )}
                    <Card.Body className="p-3 bg-white">
                      <div className="d-flex flex-column">
                        <h6 className="fw-semibold mb-2" title={material.name}>
                          {material.name}
                        </h6>
                        <div className="text-muted small mb-2">
                          <i className="bi bi-tools me-1"></i>
                          {material.workName}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <Alert variant="light" className="border text-center py-4 mb-4">
            <i className="bi bi-box fs-3 text-muted d-block mb-2"></i>
            <p className="mb-0 text-muted">
              В работах этого этапа еще не добавлены материалы
            </p>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 pb-4 px-4">
        {allMaterials.length > 0 && (
          <Button variant="primary" onClick={handleDownloadPdf}>
            <i className="bi bi-file-pdf me-2"></i>
            Скачать PDF
          </Button>
        )}
        <Button variant="outline-secondary" onClick={onHide}>
          <i className="bi bi-x-lg me-2"></i>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default StageMaterialsModal
